import { useEffect, useState } from "react";
import { useAppDispatch } from "../../store/hooks";
import {
  fetchQtechLaunchUrl,
  fetchGapCasinoLaunchUrl,
} from "../../store/slices/casinoSlice";
import "./MlobbyIframeNew.scss";
import { useParams } from "react-router-dom";

const CasinoIframe = () => {
  const dispatch = useAppDispatch();

  const { providerCode, gameId, category } = useParams();

  const [gameSrc, setGameSrc] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => {
      const run = async () => {
        setLoading(true);
        try {
          let result;
          if (category) {
            result = await dispatch(
              fetchGapCasinoLaunchUrl({
                category,
                gameId,
                providerName: providerCode,
              }),
            ).unwrap();
          } else {
            result = await dispatch(
              fetchQtechLaunchUrl({
                gameId: gameId || "",
                providerCode: providerCode || "",
              }),
            ).unwrap();
          }

          const url = result?.launchUrl || "";

          if (url) setGameSrc(url);
        } catch {
        } finally {
          setLoading(false);
        }
      };
      run();
    }, 3000);

    return () => clearTimeout(t);
  }, [dispatch, gameId, providerCode]);

  return (
    <>
      <>
        {loading ? (
          <div className="w-full py-10 text-center font-semibold">
            Loading game...
          </div>
        ) : (
          <iframe
            src={gameSrc}
            title="Casino game"
            allowFullScreen
            sandbox="allow-same-origin allow-forms allow-scripts allow-top-navigation allow-popups"
            className="game-iframe"
          />
        )}
      </>
    </>
  );
};

export default CasinoIframe;
